(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name commons.directive:uiMaskAutoComplete
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="commons">
     <file name="index.html">
     <ui-mask-auto-complete></ui-mask-auto-complete>
     </file>
     </example>
     *
     */
    angular
        .module('commons')
        .directive('uiMaskAutoComplete', uiMaskAutoComplete);

    function uiMaskAutoComplete($timeout) {
        return {
            restrict: 'EA',
            scope: {},
            require: '^?ngModel',
            replace: false,
            controllerAs: 'uiMaskAutoComplete',
            controller: function () {
                var vm = this;
                vm.name = 'uiMaskAutoComplete';

            },
            link: function (scope, element, attrs, ctrl) {
                /* jshint unused:false */
                /* eslint "no-unused-vars": [2, {"args": "none"}] */

                element.on('blur', function () {
                    if(ctrl){
                        var srtVal = element[0].value;
                        if(srtVal.charAt(0)!=="H"){
                            var res = srtVal.replace(/([HM])/g, '0');
                            ctrl.$setViewValue(res);
                            ctrl.$setValidity('mask', function(){
                                return true;
                            });
                            element[0].value = res;
                        }


                    }

                 });
                $timeout(function () {
                    element.addClass('ng-not-empty');
                },0)
            }
        };
    }
}());
